export default __webpack_public_path__ + "static/media/nft-opensea.9fbf2d68.svg";